(() => {
  if (window.__AUTO_GIFT_RUNNING__) return;
  window.__AUTO_GIFT_RUNNING__ = true;

  const CONFIG = window.AutoGiftConfig;
  if (!CONFIG) return;

  let busy = false;
  const SESSION_KEY = 'autoGiftChecked';

  function addGiftNotice() {
    const cartNotification = document.querySelector('#cart-notification .cart-notification__links');
    if (!cartNotification) return;
    
    if (cartNotification.querySelector('.auto-gift-notice')) return;
    
    const notice = document.createElement('div');
    notice.className = 'auto-gift-notice';
    notice.textContent = '🎁 Your free welcome gifts have been added to your cart';
    cartNotification.appendChild(notice);
  }

  function removeGiftNotice() {
    const notice = document.querySelector('.auto-gift-notice');
    if (notice) {
      notice.remove();
    }
  }

  function addCartDrawerMessage() {
    const cartDrawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!cartDrawer) return;

    // Remove existing message if present
    const existingMessage = cartDrawer.querySelector('.auto-gift-drawer-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    // Find cart items container or drawer content
    const cartItems = cartDrawer.querySelector('.cart-items, .cart__items, [id*="cart-items"]');
    const drawerContent = cartDrawer.querySelector('.cart-drawer__content, .drawer__inner');
    const targetContainer = cartItems || drawerContent || cartDrawer;

    if (targetContainer) {
      const message = document.createElement('div');
      message.className = 'auto-gift-drawer-message';
      message.style.cssText = 'padding: 1rem; margin: 1rem 0; background: #f0f9ff; border-left: 3px solid #0ea5e9; border-radius: 4px; font-size: 0.9rem; color: #0c4a6e;';
      message.textContent = 'Free items added to this purchase';
      
      // Insert at the top of the container
      if (targetContainer.firstChild) {
        targetContainer.insertBefore(message, targetContainer.firstChild);
      } else {
        targetContainer.appendChild(message);
      }
    }
  }

  function removeCartDrawerMessage() {
    const message = document.querySelector('.auto-gift-drawer-message');
    if (message) {
      message.remove();
    }
  }

  async function refreshCartDrawer() {
    try {
      // Fetch updated cart state
      const cart = await fetchCart();
      if (!cart) return;

      // Update cart count bubble
      const cartCountBubble = document.querySelector('.cart-count-bubble, cart-icon-bubble');
      if (cartCountBubble) {
        const count = cart.item_count || 0;
        cartCountBubble.textContent = count > 0 ? count : '';
        cartCountBubble.style.display = count > 0 ? '' : 'none';
      }

      // Update "View cart" button text
      const cartNotificationButton = document.querySelector('#cart-notification-button');
      if (cartNotificationButton) {
        const count = cart.item_count || 0;
        cartNotificationButton.textContent = `View cart (${count})`;
      }

      // Use Dawn's native cart drawer rendering if available
      const cartDrawerElement = document.querySelector('cart-drawer');
      if (cartDrawerElement && typeof cartDrawerElement.renderContents === 'function') {
        // Preserve open state
        const wasOpen = cartDrawerElement.hasAttribute('open');
        cartDrawerElement.renderContents(cart);
        // Restore open state if it was open
        if (wasOpen) {
          cartDrawerElement.setAttribute('open', '');
        }
      } else if (window.cartDrawer && typeof window.cartDrawer.renderContents === 'function') {
        window.cartDrawer.renderContents(cart);
      } else {
        // Fallback: fetch and update cart sections
        const sections = 'cart-drawer,cart-icon-bubble,cart-notification';
        const response = await fetch(`/?sections=${sections}`);
        if (response.ok) {
          const data = await response.json();
          const parser = new DOMParser();

          if (data['cart-drawer']) {
            const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
            const cartDrawer = document.querySelector('#CartDrawer, cart-drawer');
            const newCartDrawer = doc.querySelector('#CartDrawer, cart-drawer');
            if (cartDrawer && newCartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
            }
          }

          if (data['cart-icon-bubble']) {
            const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
            const cartIconBubble = document.querySelector('.cart-count-bubble, cart-icon-bubble');
            const newCartIconBubble = doc.querySelector('.cart-count-bubble, cart-icon-bubble');
            if (cartIconBubble && newCartIconBubble) {
              cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
            }
          }

          if (data['cart-notification']) {
            const doc = parser.parseFromString(data['cart-notification'], 'text/html');
            const cartNotification = document.querySelector('#cart-notification, cart-notification');
            const newCartNotification = doc.querySelector('#cart-notification, cart-notification');
            if (cartNotification && newCartNotification) {
              cartNotification.innerHTML = newCartNotification.innerHTML;
            }
          }
        }
      }

      // Update cart notification if available
      if (window.cartNotification && typeof window.cartNotification.renderContents === 'function') {
        window.cartNotification.renderContents(cart);
      } else if (window.cartNotification && typeof window.cartNotification.update === 'function') {
        window.cartNotification.update(cart);
      }

      // Dispatch Dawn-compatible events with cart detail
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Add cart drawer message after a brief delay to ensure drawer is rendered
      setTimeout(() => {
        const giftsInCart = cart.items.filter(i =>
          CONFIG.giftVariants.includes(i.variant_id)
        );
        if (giftsInCart.length > 0) {
          addCartDrawerMessage();
        } else {
          removeCartDrawerMessage();
        }
      }, 100);

    } catch (e) {
      // Fail silently
    }
  }

  async function refreshCartUI() {
    // Alias for backward compatibility
    return refreshCartDrawer();
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function changeItem(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (res.ok) {
        return true;
      }
    } catch (e) {
      // Fail silently
    }
    return false;
  }

  async function addVariant(id) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      if (res.ok) {
        return true;
      }
    } catch (e) {
      // Fail silently
    }
    return false;
  }

  async function syncGifts() {
    if (busy) return;
    busy = true;

    try {
      const cart = await fetchCart();
      if (!cart) {
        busy = false;
        return;
      }

      const totalPrice = cart.total_price || cart.items_subtotal_price;
      const giftsInCart = cart.items.filter(i =>
        CONFIG.giftVariants.includes(i.variant_id)
      );

      if (totalPrice >= CONFIG.thresholdCents) {
        // Ensure all gift variants are present
        let giftsAdded = false;
        for (const variantId of CONFIG.giftVariants) {
          const exists = giftsInCart.find(i => i.variant_id === variantId);
          if (!exists) {
            await addVariant(variantId);
            giftsAdded = true;
          }
        }
        
        // Refresh cart drawer once after all gifts are added
        if (giftsAdded) {
          await refreshCartDrawer();
          addGiftNotice();
        }
      } else {
        // Remove all gift variants if threshold not met
        let giftsRemoved = false;
        for (const gift of giftsInCart) {
          await changeItem(gift.key, 0);
          giftsRemoved = true;
        }
        
        // Refresh cart drawer once after all gifts are removed
        if (giftsRemoved) {
          await refreshCartDrawer();
          removeGiftNotice();
          removeCartDrawerMessage();
        }
      }

      // Update cart total display if on cart page
      if (window.location.pathname.includes('/cart')) {
        updateCartTotalDisplay();
      }

      // Mark as checked in this session (only for initial page load prevention)
      sessionStorage.setItem(SESSION_KEY, Date.now().toString());

    } catch (e) {
      // Fail silently - but log for debugging
      console.error('[AutoGift] Error in syncGifts:', e);
    } finally {
      busy = false;
    }
  }

  // Intercept ALL fetch requests to /cart/add (with or without .js)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    
    // Check if this is a cart add request (both /cart/add and /cart/add.js)
    if (url.includes('/cart/add')) {
      const fetchPromise = originalFetch.apply(this, args);
      
      // After successful add, wait for Dawn to finish, then sync gifts
      fetchPromise
        .then(async (res) => {
          if (res.ok) {
            // Wait for Dawn's cart:updated event, then sync gifts
            const handleCartUpdated = () => {
              setTimeout(() => {
                syncGifts();
              }, 300);
            };
            
            // Listen for Dawn's cart:updated event
            document.addEventListener('cart:updated', handleCartUpdated, { once: true });
            
            // Fallback: if event doesn't fire within 800ms, sync anyway
            setTimeout(() => {
              document.removeEventListener('cart:updated', handleCartUpdated);
              syncGifts();
            }, 800);
          }
        })
        .catch(() => {
          // Fail silently
        });
      
      return fetchPromise;
    }
    
    return originalFetch.apply(this, args);
  };

  // Run on page load
  function init() {
    // Check if we've already run in this session (prevent duplicate adds on same page)
    const lastCheck = sessionStorage.getItem(SESSION_KEY);
    const now = Date.now();
    
    // If checked less than 2 seconds ago, skip (likely same page reload)
    if (lastCheck && (now - parseInt(lastCheck, 10)) < 2000) {
      return;
    }

    // Run sync after a short delay to ensure DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(syncGifts, 500);
      });
    } else {
      setTimeout(syncGifts, 500);
    }
  }

  // Also listen for Dawn events (for desktop cart drawer compatibility)
  document.addEventListener('cart:updated', () => {
    // Clear session check to allow sync on cart updates
    sessionStorage.removeItem(SESSION_KEY);
    setTimeout(syncGifts, 300);
  });

  document.addEventListener('cart:refresh', () => {
    if (window.Shopify && Shopify.theme && Shopify.theme.cart) {
      Shopify.theme.cart.refresh?.();
    }
  });

  // Intercept form submissions to /cart/add
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      // Wait for form submission to complete
      setTimeout(() => {
        syncGifts();
      }, 500);
    }
  });

  // Update cart page total display with savings message
  async function updateCartTotalDisplay() {
    // Only run on cart page
    if (!window.location.pathname.includes('/cart')) return;

    try {
      const cart = await fetchCart();
      if (!cart || !cart.items) return;

      // Identify free items (gift variants or items with price = 0)
      const giftVariantIds = CONFIG.giftVariants.map(id => String(id));
      let freeItemsTotal = 0;
      let hasFreeItems = false;

      cart.items.forEach(item => {
        const isGiftVariant = giftVariantIds.includes(String(item.variant_id));
        const isFree = item.final_line_price === 0 || item.original_line_price > item.final_line_price;
        
        if (isGiftVariant || isFree) {
          hasFreeItems = true;
          // Use original_line_price if available, otherwise use original_price * quantity
          const originalPrice = item.original_line_price || (item.original_price * item.quantity);
          freeItemsTotal += originalPrice;
        }
      });

      if (!hasFreeItems || freeItemsTotal === 0) return;

      // Calculate original total (current total + original prices of free items)
      const currentTotal = cart.total_price;
      const originalTotal = currentTotal + freeItemsTotal;
      const savings = freeItemsTotal;

      // Format prices (convert from cents to pounds)
      const formatPrice = (cents) => {
        return (cents / 100).toFixed(2);
      };

      // Find the totals section and total value element
      const totalsSection = document.querySelector('.totals');
      const totalValueElement = document.querySelector('.totals__total-value');
      
      if (!totalsSection || !totalValueElement) return;

      // Check if we've already updated this element
      if (totalValueElement.dataset.savingsUpdated === 'true') {
        // Just update the values
        const existingOriginal = totalValueElement.querySelector('.cart-total-original');
        const existingCurrent = totalValueElement.querySelector('.cart-total-current');
        const existingSavings = totalValueElement.querySelector('.cart-total-savings');
        const existingMessage = totalsSection.querySelector('.cart-free-items-message');

        if (existingOriginal) existingOriginal.textContent = `£${formatPrice(originalTotal)}`;
        if (existingCurrent) existingCurrent.textContent = `£${formatPrice(currentTotal)}`;
        if (existingSavings) {
          existingSavings.textContent = `Saved £${formatPrice(savings)} today`;
          existingSavings.style.fontSize = '1.4rem';
        }
        if (existingMessage) {
          existingMessage.textContent = `🎁 Includes £${formatPrice(freeItemsTotal)} in free items`;
          existingMessage.style.fontSize = '1.3rem';
        }

        return;
      }

      // Mark as updated
      totalValueElement.dataset.savingsUpdated = 'true';

      // Ensure "Estimated total" heading stays on one line
      const totalsHeading = totalsSection.querySelector('.totals__total');
      if (totalsHeading) {
        totalsHeading.style.whiteSpace = 'nowrap';
      }

      // Update the total value to show original (crossed out) and current price
      totalValueElement.innerHTML = `
        <div style="display: flex; flex-direction: column; gap: 0.5rem;">
          <div style="display: flex; align-items: baseline; gap: 0.8rem; flex-wrap: wrap;">
            <span class="cart-total-original" style="text-decoration: line-through; color: #6b7280; font-size: 1.4rem;">
              £${formatPrice(originalTotal)}
            </span>
            <span class="cart-total-current money" style="font-size: 1.8rem; font-weight: 600; color: #111;">
              £${formatPrice(currentTotal)}
            </span>
            <span class="cart-total-savings" style="color: #059669; font-size: 1.4rem; font-weight: 500;">
              Saved £${formatPrice(savings)} today
            </span>
          </div>
        </div>
      `;

      // Add free items message below the totals section
      let freeItemsMessage = totalsSection.querySelector('.cart-free-items-message');
      if (!freeItemsMessage) {
        freeItemsMessage = document.createElement('p');
        freeItemsMessage.className = 'cart-free-items-message';
        freeItemsMessage.style.cssText = 'color: #059669; font-size: 1.3rem; margin-top: 0.5rem; margin-bottom: 0;';
        totalsSection.appendChild(freeItemsMessage);
      }
      freeItemsMessage.textContent = `🎁 Includes £${formatPrice(freeItemsTotal)} in free items`;
    } catch (error) {
      console.error('Error updating cart total display:', error);
    }
  }

  // Initialize
  init();

  // Update cart total display on cart page
  if (window.location.pathname.includes('/cart')) {
    const runUpdate = () => {
      setTimeout(updateCartTotalDisplay, 500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runUpdate);
    } else {
      runUpdate();
    }

    // Update after cart changes
    document.addEventListener('cart:updated', runUpdate);
    document.addEventListener('cart:refresh', runUpdate);

    // Watch for cart total element changes (in case Dawn updates it dynamically)
    let updateTimeout;
    const cartObserver = new MutationObserver(() => {
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(runUpdate, 300);
    });

    // Observe cart totals area for changes
    const observeCartTotals = () => {
      const cartTotals = document.querySelector('.cart__totals, .cart-totals, [data-cart-totals]');
      if (cartTotals) {
        cartObserver.observe(cartTotals, { childList: true, subtree: true, characterData: true });
      } else {
        setTimeout(observeCartTotals, 500);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCartTotals);
    } else {
      observeCartTotals();
    }
  }

  // Expose syncGifts for manual testing (remove in production if desired)
  window.autoGiftSync = syncGifts;

})();
